<template>
    <div class="vip-u">
        <div class="absolute top-170px z-2 left-5% w-90% tab-subscribe-box">
            <div v-for="(value, index) in equityPlusList">
                <div class="flex justify-between items-center p-10px px-20px"
                    :class="index % 2 === 0 ? 'singular' : 'even_number'">
                    <div class="flex items-center">
                        <div class="mr-10px w-32px h-32px">
                            <img :src="value.titleIcon" alt="">
                        </div>
                        <div class="text-14px font-500">
                            {{ value.title }}
                        </div>
                    </div>
                    <div v-if="!value.isText">
                        <img :src="value.dui" alt="">
                    </div>
                    <div v-else class="color-#FFFFFF66">
                        {{ value.text }}
                    </div>
                </div>
            </div>
        </div>
        <div class="p-20px py-0! pt-10px! absolute bottom-0 left-0 right-0 bg-#19100F tab-box">
            <div v-if="![4, 5].includes(userInfo?.role)">
                <div class="flex items-center justify-center">
                    <div class="flex items-center justify-center w-14px h-14px">
                        <img src="@/assets/images/home/crystal.webp" class="w-100% h-100%">
                    </div>
                    <div class="text-14px">
                        {{ vipPerksPlus?.plus?.packagesList[0]?.giftAmount + vipPerksPlus?.plus?.packagesList[0]?.amount
                        }}/Month
                    </div>

                    <div class="text-12px color-#888 mt-2px">
                        (Valued at ${{ vipPerksPlus?.plus?.packagesList[0].price / 100 }})
                    </div>
                </div>
                <div class="h-70px flex items-center justify-center">
                    <div class="subscribe-now-btn" @click="handleSubscribeNow">
                        Join Now
                    </div>
                </div>
            </div>
            <div v-else class="h-100px ultru_active_box">
                <div class="title">
                    Ultra VIP Activated
                </div>
                <div class="content">
                    Expires on: xxxx:xx:xx
                </div>
            </div>
            <div class="flex gap-10px color-text-1 justify-between py-10px">
                <div class="text-12px font-500 underline" @click="router.push('/terms')">
                    Terms of Use
                </div>
                <!-- <div class="text-12px font-500">
                    Cancel at any time
                </div> -->
                <div class="text-12px font-500 underline" @click="router.push('/policy')">
                    Privacy Policy
                </div>
            </div>
        </div>
        <!-- 挽留弹窗 -->
        <Transition name="retention-popup">
            <div v-if="showRetentionPopup" class="retention-popup-overlay" @click.self="handleCloseRetention">
                <div class="retention-popup-wrapper">
                    <div class="retention-popup-container">
                        <!-- 皇冠图标区域 -->
                        <div class="retention-icon-wrapper">
                            <div class="retention-icon-border">
                                <div class="retention-icon-circle">
                                    <img src="@/assets/images/vip/stay_picon.svg" alt="" class="retention-crown-icon">
                                </div>
                            </div>
                        </div>

                        <!-- 标题 -->
                        <div class="retention-title">Still hesitating?</div>

                        <!-- 描述 -->
                        <div class="retention-description">
                            Once unlocked, you won't need to worry about diamond consumption.
                        </div>

                        <!-- 按钮组 -->
                        <div class="retention-buttons">
                            <div class="retention-btn retention-btn-secondary" @click="handleCloseRetention">
                                Next time
                            </div>
                            <div class="retention-btn retention-btn-primary" @click="handleSubscribeNow">
                                Buy now
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script setup lang="ts">
import { showLoadingToast, showSuccessToast, showErrorToast, closeToast } from '@/utils/toast'
import { VipAPI } from '@/services/vip'
import { useVipStore } from '@/stores/vip'
import { theme } from '@/styles/theme'
import { vipPlusBenefitList, equityPlusList } from '../index'
import { useRouter } from 'vue-router'
import { computed } from 'vue'
import { useUserStore } from '@/stores/user'
import { ref } from 'vue'
import bridge from '@/utils/bridge'
const userStore = useUserStore()
const vipStore = useVipStore()
const userInfo = computed(() => userStore.userInfo)
const router = useRouter()
const props = defineProps({
    vipPlusBenefitList: {
        type: Function,
        default: () => () => []
    },
    vipPerksPlus: {
        type: Object,
        default: () => { }
    }
})
const activePackage = ref<number>(0)
const vipPlusItem = ref<any>({})
const handleSubscribeNow = async () => {
    showLoadingToast('Purchasing...')
    showRetentionPopup.value = false
    // 获取套餐信息
    localStorage.setItem('nowMsgCost', String(userStore.msgCost))
    if (!vipPlusItem.value.isVip) {
        vipPlusItem.value = props.vipPerksPlus?.plus?.packagesList[activePackage.value]
        vipPlusItem.value.isVip = true
    }

    try {
        const res = await VipAPI.getSubscribePackagesCount({
            productId: props.vipPerksPlus?.plus?.packagesList[0].productId
        })
        if (res.code === 200) {
            showSuccessToast('Purchase successful')
            userStore.getUserInfo()
            // userStore.loginTouristFunc()
            // handleCloseRetention()
        } else {
            showErrorToast(res.message)
        }
    } catch (error) {
        closeToast
    } finally {
        closeToast()
    }

}


const showRetentionPopup = ref(false)
const handleShowRetentionPopup = () => {
    showRetentionPopup.value = true
}
const handleCloseRetention = () => {
    showRetentionPopup.value = false
    router.back()
}

const formatDate = (ts: number) => {
    const date = new Date(ts * 1000); // 秒 → 毫秒
    const pad = (n: number) => String(n).padStart(2, '0');

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

defineExpose({
    handleShowRetentionPopup
})

window.addEventListener('paymentResult', function () {
    showRetentionPopup.value = false
});
</script>

<style scoped lang="scss">
.text {
    // background: linear-gradient(0deg, #974BFF 0%, #CFABFF 47%, #974BFF 100%);
    background: linear-gradient(0deg, #EAB04E 0%, #FFDFB3 47%, #EAB04E 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 24px;
    color: #FFFFFF;
    line-height: 29px;
    text-align: left;
    font-style: italic;
    font-weight: 600;
}

.singular {
    background-color: rgba(255, 255, 255, 0.05);
}

.even_number {
    background-color: rgba(25, 16, 15, 0.1);
}

.tab-subscribe-box {
    height: 315px;
    border-radius: 15px 15px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.05);
}

.vip-u {
    .vip-u-text {
        margin-top: 14px;
        text-align: center;
        // background: linear-gradient(0deg, #AD62F2 0%, #D4B3FF 47%, #AD62F2 100%);
        background: linear-gradient(0deg, #EAB04E 0%, #FFDFB3 47%, #EAB04E 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        font-weight: 800;
        font-size: 20px;
        font-style: italic;
    }

    .vip-u-text-2 {
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: v-bind('theme.colors.textPrimary');
    }

    .vip-u-benefit-box {
        .vip-u-benefit-list {
            border-radius: 15px;
            border: 1px solid #B5ADA1;

            // border-image: linear-gradient(180deg, rgba(174, 161, 181, 1), rgba(186, 138, 221, 1)) 1 1;
            .header-item {
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            }
        }
    }

    .top {
        width: 59px;
        height: calc(100% + 20px);
        position: absolute;
        bottom: -30px;
        left: 270px;
        background: linear-gradient(180deg, rgba(255, 223, 179, 0.28) 0%, rgba(255, 223, 179, 0) 100%);
        opacity: 0.9;
    }

    .bottom {
        position: absolute;
        top: -20px;
        left: 270px;
        width: 59px;
        height: 30px;
        border-radius: 10px 10px 0 0;
        // opacity: 0.9;
        background: #5E4D40;
    }

    .tab-box {
        // box-shadow: 0px -4px 10px 2px rgba(0, 0, 0, 1);
    }


    .subscribe-now-btn {
        // margin-top: 20px;
        width: 100%;
        height: 40px;
        // background: linear-gradient(90deg, #E9D6FF 0%, #A66CFE 100%);
        background: linear-gradient(90deg, #FFDFB3 0%, #EAB04E 100%);
        border-radius: 35px;
        text-align: center;
        line-height: 40px;
        font-weight: 800;
        font-size: 15px;
        // color: #490D73;
        color: #854A0D;
    }

    .off-pic-box {
        // background: url('@/assets/images/vip/off-pic.png') no-repeat center center;
        // background-size: 100% 100%;
        border-radius: 20px;
        font-weight: bold;
        font-size: 9px;
        color: #FFFFFF;
    }
}

.bg-color {
    background-color: rgba(67, 58, 73, 0.4);

}

// 挽留弹窗样式
.retention-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.retention-popup-wrapper {
    width: 100%;
    max-width: 335px;
    padding: 1px;
    background: linear-gradient(314deg, rgba(233, 176, 78, 1), rgba(255, 222, 178, 1));
    // border-image: linear-gradient(135deg, rgba(233, 214, 255, 1), rgba(166, 108, 254, 1));
    border-radius: 20px;
    position: relative;
}

.retention-popup-container {
    width: 100%;
    // background: linear-gradient(180deg, #1D265F 0%, #171A2A 100%);
    // background: linear-gradient( 180deg, #40166B 0%, #140325 100%);
    background: linear-gradient(180deg, #513516 0%, #30241A 100%);
    border-radius: 20px;
    padding: 30px 20px 20px;
    position: relative;
    // box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.retention-icon-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.retention-icon-border {
    position: relative;
    // padding: 8px;
    // border: 1px dashed rgba(214, 223, 255, 0.5);
    border-radius: 8px;
}

.retention-icon-circle {
    width: 107px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.retention-crown-icon {
    width: 100%;
    height: 100%;
}

.retention-title {
    text-align: center;
    font-size: 17px;
    font-weight: 900;
    color: #FFFFFF;
    margin-bottom: 12px;
}

.retention-description {
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 1.5;
    margin-bottom: 24px;
    opacity: 0.9;
}

.retention-buttons {
    display: flex;
    gap: 12px;
    justify-content: center;
}

.retention-btn {
    flex: 1;
    padding: 8px 20px;
    border-radius: 23px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
}

.retention-btn-secondary {
    background: rgba(255, 255, 255, 0.1);
    color: #FFFFFF;
    font-weight: 800;
    font-size: 14px;
    color: #FFFFFF;

    &:active {
        background: rgba(255, 255, 255, 0.2);
        transform: scale(0.98);
    }
}

.retention-btn-primary {
    // background: linear-gradient(90deg, #5A68FF 0%, #95A5FF 100%);
    // background: linear-gradient(90deg, #D6DFFF 0%, #6990FF 100%);
    // background: linear-gradient( 90deg, #E9D6FF 0%, #A66CFE 100%);
    background: linear-gradient(90deg, #FFDFB3 0%, #EAB04E 100%);
    color: #FFFFFF;
    font-weight: 800;
    font-size: 15px;
    // color: #0D1D73;/
    // color: #490D73;
    color: #854A0D;

    &:active {
        opacity: 0.9;
        transform: scale(0.98);
    }
}

// 弹窗动画
.retention-popup-enter-active,
.retention-popup-leave-active {
    transition: opacity 0.3s ease;
}

.retention-popup-enter-active .retention-popup-wrapper,
.retention-popup-leave-active .retention-popup-wrapper {
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.retention-popup-enter-from {
    opacity: 0;
}

.retention-popup-enter-from .retention-popup-wrapper {
    transform: scale(0.9) translateY(20px);
    opacity: 0;
}

.retention-popup-leave-to {
    opacity: 0;
}

.retention-popup-leave-to .retention-popup-wrapper {
    transform: scale(0.9) translateY(-20px);
    opacity: 0;
}
.ultru_active_box {
    background: url('@/assets/images/vip/caidai-vip-plus.webp') no-repeat center center;
    background-size: 100% 100%;
    border-radius: 15px;
    padding: 10px;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    line-height: 100px;
    position: relative;
    width: 100%;
    .title {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        // background: linear-gradient(0deg, #AD62F2 0%, #D4B3FF 47%, #AD62F2 100%);
        background: linear-gradient(0deg, #EAB04E 0%, #FFDFB3 47%, #EAB04E 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        font-weight: 800;
        font-size: 20px;
        color: #FFFFFF;
        font-style: italic;
        width: 100%;
    }
    .content {
        width: 100%;
        position: absolute;
        top: 80%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
    }
}
</style>